import React, { useContext } from "react";
import { Switch, Route } from "react-router-dom";

/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import UiAccordion from "./components/bootstrap/Accordion";
/// Bootstrap
import UiAlert from "./components/bootstrap/Alert";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiGrid from "./components/bootstrap/Grid";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiModal from "./components/bootstrap/Modal";
import UiPagination from "./components/bootstrap/Pagination";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiTypography from "./components/bootstrap/Typography";
/// Charts
import ApexChart from "./components/charts/apexcharts";
import Chartist from "./components/charts/chartist";
import ChartJs from "./components/charts/Chartjs";
import RechartJs from "./components/charts/rechart";
import SparklineChart from "./components/charts/Sparkline";
/// Courses
import ActivityLogs from "./components/Courses/ActivityLogs";
import ActivityTrackerTable from "./components/Courses/ActivityTracker";
import CourseDetail1 from "./components/Courses/CourseDetail1";
import CourseDetail2 from "./components/Courses/CourseDetail2";
import CoursesMain from "./components/Courses/CoursesMain";
import Reports from "./components/Courses/Reports";
import Tasks from "./components/Courses/Task";
import users from "./components/Courses/User";
/// Dashboard
import Activity from "./components/Dashboard/Activity";
import DashboardDark from "./components/Dashboard/DashboardDark";
import Theme1 from "./components/Dashboard/Demo/Theme1";
import Theme2 from "./components/Dashboard/Demo/Theme2";
import Theme3 from "./components/Dashboard/Demo/Theme3";
import Theme4 from "./components/Dashboard/Demo/Theme4";
import Theme5 from "./components/Dashboard/Demo/Theme5";
import Theme6 from "./components/Dashboard/Demo/Theme6";
import Theme7 from "./components/Dashboard/Demo/Theme7";
import Theme8 from "./components/Dashboard/Demo/Theme8";
import Home from "./components/Dashboard/Home";
import Instructors from "./components/Dashboard/Instructors";
import Message from "./components/Dashboard/Message";
import Profile from "./components/Dashboard/Profile";
import Schedule from "./components/Dashboard/Schedule";
/// Eticketing - Boating
import Boatingdashboard from "./components/Eticketing/Boating/BoatingDashboard";
import BoatingReservations from "./components/Eticketing/Boating/BoatingReservations";
import BoatingRoutes from "./components/Eticketing/Boating/BoatingRoutes";
import BoatingUsers from "./components/Eticketing/Boating/BoatingUsers";
import BoatingCMS from "./components/Eticketing/Boating/BoatingWebCMS";
/// Eticketing - ChairLift
import ChairLiftCMS from "./components/Eticketing/ChairLift/ChairLiftCMS";
import ChairliftDb from "./components/Eticketing/ChairLift/ChairliftDB";
import ChairLiftusers from "./components/Eticketing/ChairLift/ChairLiftusers";
import Prices from "./components/Eticketing/ChairLift/Prices";
import ChairLiftReservations from "./components/Eticketing/ChairLift/Reservations";
import Routes from "./components/Eticketing/ChairLift/Routes.jsx";
import ChairLiftServiceCategory from "./components/Eticketing/ChairLift/ServiceCategory";
import Timings from "./components/Eticketing/ChairLift/Timings";
/// Eticketing
import EticketDashboard from "./components/Eticketing/EticketDashboard";
/// Eticketing - Golf Cart
import GoldWebCMS from "./components/Eticketing/GolfCart/golfCMS";
import GoldDashboard from "./components/Eticketing/GolfCart/golfDashboard";
import GoldReservations from "./components/Eticketing/GolfCart/golfReservations";
import GoldRoutes from "./components/Eticketing/GolfCart/golfRoutes";
import GoldUsers from "./components/Eticketing/GolfCart/golfUsers";
/// Eticketing - Parking
import ParkingDashboard from "./components/Eticketing/Parking/ParkingDashBoard";
import ParkingReservations from "./components/Eticketing/Parking/ParkingReservations";
import ParkingServiceCategory from "./components/Eticketing/Parking/ParkingServiceCategory";
import ParkingUsers from "./components/Eticketing/Parking/ParkingUsers";
/// Eticketing - Service Manager
import Bus from "./components/Eticketing/ServiceManager/Bus.jsx";
import SMCity from "./components/Eticketing/ServiceManager/City";
import SMReseorts from "./components/Eticketing/ServiceManager/Resorts";
import SMServices from "./components/Eticketing/ServiceManager/Services";
/// Eticketing - Sightseeing
import SightseeingDashboard from "./components/Eticketing/Sightseeing/SighDashBoard";
import SightseeingBusCategory from "./components/Eticketing/Sightseeing/SightBusCategory";
import SightseeingReservations from "./components/Eticketing/Sightseeing/SightReservations";
import SightseeingRoutes from "./components/Eticketing/Sightseeing/SightRoutes";
import SightseeingUsers from "./components/Eticketing/Sightseeing/SightUsers";
import SightseeingWebCMS from "./components/Eticketing/Sightseeing/SightWebCMS";
/// Eticketing - Train
import TrainDashboard from "./components/Eticketing/Train/TrainDashboard";
import TrainReservation from "./components/Eticketing/Train/TrainReservations";
import TrainRoutes from "./components/Eticketing/Train/TrainRoutes";
import TrainUser from "./components/Eticketing/Train/TrainUsers";
import TrainWebCMS from "./components/Eticketing/Train/TrainWebCMS";
/// Forms
import Element from "./components/Forms/Element/Element";
import jQueryValidation from "./components/Forms/jQueryValidation/jQueryValidation";
import Pickers from "./components/Forms/Pickers/Pickers";
import SummerNote from "./components/Forms/Summernote/SummerNote";
import Wizard from "./components/Forms/Wizard/Wizard";
/// Instructor
import InstructorCourses from "./components/Instructor/InstructorCourses";
import InstructorDashboard from "./components/Instructor/InstructorDashboard";
import InstructorResources from "./components/Instructor/InstructorResources";
import InstructorSchedule from "./components/Instructor/InstructorSchedule";
import InstructorStudents from "./components/Instructor/InstructorStudents";
import InstructorTransactions from "./components/Instructor/InstructorTransactions";
/// Plugins
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";
import MainNouiSlider from "./components/PluginsMenu/NouiSlider/MainNouiSlider";
import Select2 from "./components/PluginsMenu/Select2/Select2";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
/// Resort Booking
import BookingCities from "./components/ResortBooking/BookingCities";
import BookingPromos from "./components/ResortBooking/BookingPromos";
import BookingReport from "./components/ResortBooking/BookingReport.js";
import BookingUsers from "./components/ResortBooking/BookingUsers";
import Hotels from "./components/ResortBooking/Hotels";
import ResortReservations from "./components/ResortBooking/ResortReservations";
import ServicesProductsPage from "./components/ResortBooking/ServicesProductsPage.js";
import WebsiteContent from "./components/ResortBooking/WebsiteContent";
import ResortsDashboard from "./pages/Resorts/Dashboard/Dashboard";
/// Tables
import BootstrapTable from "./components/table/BootstrapTable";
import DataTable from "./components/table/DataTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import SortingTable from "./components/table/SortingTable/SortingTable";
/// Layout
import Footer from "./layouts/Footer";
import Nav from "./layouts/nav";
import ScrollToTop from "./layouts/ScrollToTop";
/// Pages
import ContentPage from "./pages/ContentPage/ContentPage.jsx";
import Content from "./pages/E-ticketing/Content/Content.jsx";
import Error404 from "./pages/Error404";
import ForgotPassword from "./pages/ForgotPassword";
import LockScreen from "./pages/LockScreen";
import Login from "./pages/Login";
import MainPages from "./pages/MainPages/MainPages";
import Registration from "./pages/Registration";
import Service from "./pages/Service/Service";
import Todo from "./pages/Todo";
import AttractionsByDestination from "./pages/TopAttractions/ByDestination";
import AttractionsByInterest from "./pages/TopAttractions/ByInterest";
import AttractionsBySite from "./pages/TopAttractions/BySite";
import User from "./pages/User/User";
import Widget from "./pages/Widget";

import NewsletterSubscriber from "./pages/NewsletterSubscriber/NewsletterSubscriber.jsx";

// Fleet Management
import FleetManagementDrivers from "./pages/FleetManagement/Drivers/Drivers";
import FleetManagementDriverFromPage from "./pages/FleetManagement/Drivers/DriverFormPage.jsx";
import FleetManagementVehicleCategories from "./pages/FleetManagement/VehicleCategory/VehicleCategories";
import FleetManagementVehicleCategoryFormPage from "./pages/FleetManagement/VehicleCategory/VehicleCategoryFormPage";
import FleetManagementVehicles from "./pages/FleetManagement/Vehicles/Vehicles";
import FleetManagementVehicleFormPage from "./pages/FleetManagement/Vehicles/VehicleFormPage";
import FleetManagementVehiclePackagesPage from "./pages/FleetManagement/Vehicles/VehiclePackagesPage";

import FleetManagementBookings from "./pages/FleetManagement/Bookings/Bookings";
import FleetManagementBookingDetailsPage from "./pages/FleetManagement/Bookings/BookingDetailsPage";
import FleetManagementCreateBookingPage from "./pages/FleetManagement/Bookings/CreateBookingPage";
import FleetManagementGeneralExpenses from "./pages/FleetManagement/GeneralExpenses/GeneralExpenses";
import FleetManagementGeneralExpenseFormPage from "./pages/FleetManagement/GeneralExpenses/GeneralExpenseFormPage";
import FleetManagementDriverExpenses from "./pages/FleetManagement/DriverExpenses/DriverExpenses";
import FleetManagementDriverExpenseFormPage from "./pages/FleetManagement/DriverExpenses/DriverExpenseFormPage";
import FleetManagementDashboard from "./pages/FleetManagement/Dashboard/Dashboard";

import TripPlanner from "./pages/TripPlanner/TripPlanner";
import EditQuotePage from "./pages/TripPlanner/EditQuote/EditQuotePage";

import EticketingDashboard from './pages/Dashboard/Dashboard.jsx'

/// Context
import { ThemeContext } from "../context/ThemeContext";

/// CSS
import "./chart.css";
import "./index.css";
import "./step.css";

const Markup = () => {
  const { menuToggle } = useContext(ThemeContext);
  const routes = [
    /// Dashboard
    { url: "", component: Home },
    { url: "dashboard", component: Home },
    { url: "dashboard-dark", component: DashboardDark },
    // { url: "users", component: Instructors },
    // { url: "activity", component: Activity },
    // { url: "profile", component: Profile },
    /// E-Ticketing
    { url: "", component: EticketDashboard },
    // ChairLift
    { url: "E-Ticketing-Dashboard", component: EticketDashboard },
    { url: "Service-Manager/:service/:serviceId/Dashboard", component: EticketingDashboard },
    {
      url: "Service-Manager/:service/:serviceId/Reservations",
      component: ChairLiftReservations,
    },
    {
      url: "Service-Manager/:service/:serviceId/Users",
      component: ChairLiftusers,
    },
    {
      url: "Service-Manager/:service/:serviceId/routes-prices",
      component: Routes,
    },
    { url: "Service-Manager/:service/:serviceId/contents", component: Content },
    { url: "chairlift-Service-Category", component: ChairLiftServiceCategory },
    { url: "chairlift-Dashboard", component: ChairliftDb },
    { url: "chairlift-CMS", component: ChairLiftCMS },
    { url: "service-timings", component: Timings },
    { url: "service-pricing", component: Prices },
    // SightSeeing
    { url: "Sightseeing-Dashboard", component: SightseeingDashboard },
    { url: "Sightseeing-Reservations", component: SightseeingReservations },
    { url: "Sightseeing-Bus-Category", component: SightseeingBusCategory },
    { url: "Sightseeing-Routes", component: SightseeingRoutes },
    { url: "Sightseeing-Users", component: SightseeingUsers },
    { url: "Sightseeing-WebCMS", component: SightseeingWebCMS },
    // Parking
    { url: "Parking-Dashboard", component: ParkingDashboard },
    { url: "Parking-Reservations", component: ParkingReservations },
    { url: "Parking-Users", component: ParkingUsers },
    { url: "Parking-Service-Category", component: ParkingServiceCategory },
    //Boating
    { url: "Boating-dashboard", component: Boatingdashboard },
    { url: "Boating-reservations", component: BoatingReservations },
    { url: "Boating-Users", component: BoatingUsers },
    { url: "Boating-WebCMS", component: BoatingCMS },
    { url: "Boating-Routes", component: BoatingRoutes },
    // train
    { url: "Train-dashboard", component: TrainDashboard },
    { url: "Train-reservations", component: TrainReservation },
    { url: "Train-Users", component: TrainUser },
    { url: "Train-WebCMS", component: TrainWebCMS },
    { url: "Train-Routes", component: TrainRoutes },
    // Golf Cart
    { url: "GolfCart-Dashboard", component: GoldDashboard },
    { url: "GolfCart-Reservations", component: GoldReservations },
    { url: "GolfCart-Users", component: GoldUsers },
    { url: "GolfCart-WebCMS", component: GoldWebCMS },
    { url: "GolfCart-Routs", component: GoldRoutes },

    // Service Manager
    { url: "Service-Manager-City", component: SMCity },
    { url: "Service-Manager-Bus", component: Bus },
    { url: "Service-Manager-Resorts", component: SMReseorts },
    { url: "Service-Manager-Services", component: SMServices },
    // Boating

    // Resort Booking
    { url: "Hotels", component: Hotels },
    { url: "invoice", component: BookingReport },
    { url: "services", component: ServicesProductsPage },
    { url: "Reservations", component: ResortReservations },
    { url: "Website-Content", component: WebsiteContent },
    { url: "Booking-Users", component: BookingUsers },
    { url: "Booking-Cities", component: BookingCities },
    { url: "Booking-Promotions", component: BookingPromos },
    { url: "Resorts-Dashboard", component: ResortsDashboard },
    // Courses ----
    { url: "inspection-dashboard", component: CoursesMain },
    { url: "Reports", component: Reports },
    { url: "Tasks", component: Tasks },
    { url: "inspection-users", component: users },
    { url: "activity-tracker", component: ActivityTrackerTable },
    { url: "activity_logs", component: ActivityLogs },

    // trip planner
    // { url: "trip-planner/dashboard", component: TripPlanner },
    // { url: "trip-planner/dashboard/:quoteId/edit", component: EditQuotePage },

    // fleet management
    { url: "fleet-management/dashboard", component: FleetManagementDashboard },
    { url: "fleet-management/drivers", component: FleetManagementDrivers },
    { url: 'fleet-management/drivers/add', component: FleetManagementDriverFromPage },
    { url: 'fleet-management/drivers/update/:driverId', component: FleetManagementDriverFromPage },
    { url: "fleet-management/vehicle-categories", component: FleetManagementVehicleCategories },
    {
      url: "fleet-management/vehicle-categories/add",
      component: FleetManagementVehicleCategoryFormPage,
    },
    {
      url: "fleet-management/vehicle-categories/update/:vehicleCategoryId",
      component: FleetManagementVehicleCategoryFormPage,
    },
    { url: "fleet-management/vehicles", component: FleetManagementVehicles },
    {
      url: "fleet-management/vehicles/add",
      component: FleetManagementVehicleFormPage,
    },
    {
      url: "fleet-management/vehicles/update/:vehicleId",
      component: FleetManagementVehicleFormPage,
    },
    {
      url: "fleet-management/vehicles/:vehicleId/packages",
      component: FleetManagementVehiclePackagesPage,
    },

    {
      url: "fleet-management/bookings",
      component: FleetManagementBookings,
    },
    {
      url: "fleet-management/bookings/create",
      component: FleetManagementCreateBookingPage,
    },
    {
      url: "fleet-management/bookings/:bookingId",
      component: FleetManagementBookingDetailsPage,
    },

    {
      url: "fleet-management/general-expenses",
      component: FleetManagementGeneralExpenses,
    },
    {
      url: "fleet-management/general-expenses/add",
      component: FleetManagementGeneralExpenseFormPage,
    },
    {
      url: "fleet-management/general-expenses/update/:generalExpenseId",
      component: FleetManagementGeneralExpenseFormPage,
    },
    {
      url: "fleet-management/driver-expenses",
      component: FleetManagementDriverExpenses,
    },
    {
      url: "fleet-management/driver-expenses/add",
      component: FleetManagementDriverExpenseFormPage,
    },
    {
      url: "fleet-management/driver-expenses/update/:driverExpenseId",
      component: FleetManagementDriverExpenseFormPage,
    },

    ///Instructors  Pages path
    { url: "instructor-dashboard", component: InstructorDashboard },
    { url: "instructor-courses", component: InstructorCourses },
    { url: "instructor-schedule", component: InstructorSchedule },
    { url: "instructor-resources", component: InstructorResources },
    { url: "instructor-students", component: InstructorStudents },
    { url: "instructor-transactions", component: InstructorTransactions },

    /////Demo
    { url: "secondary-sidebar", component: Theme1 },
    { url: "mini-primary-sidebar", component: Theme2 },
    { url: "nav-header", component: Theme3 },
    { url: "horizontal-header", component: Theme4 },
    { url: "header-nav", component: Theme5 },
    { url: "sidebar-theme", component: Theme6 },
    { url: "dark-sidebar", component: Theme7 },
    { url: "theme-dashboard", component: Theme8 },

    /// Apps
    { url: "app-profile", component: AppProfile },
    { url: "email-compose", component: Compose },
    { url: "email-inbox", component: Inbox },
    { url: "email-read", component: Read },
    { url: "app-calender", component: Calendar },
    { url: "post-details", component: PostDetails },

    /// Chart
    { url: "chart-sparkline", component: SparklineChart },
    { url: "chart-chartjs", component: ChartJs },
    { url: "chart-chartist", component: Chartist },
    { url: "chart-apexchart", component: ApexChart },
    { url: "chart-rechart", component: RechartJs },

    /// Bootstrap
    { url: "ui-alert", component: UiAlert },
    { url: "ui-badge", component: UiBadge },
    { url: "ui-button", component: UiButton },
    { url: "ui-modal", component: UiModal },
    { url: "ui-button-group", component: UiButtonGroup },
    { url: "ui-accordion", component: UiAccordion },
    { url: "ui-list-group", component: UiListGroup },
    { url: "ui-card", component: UiCards },
    { url: "ui-carousel", component: UiCarousel },
    { url: "ui-dropdown", component: UiDropDown },
    { url: "ui-popover", component: UiPopOver },
    { url: "ui-progressbar", component: UiProgressBar },
    { url: "ui-tab", component: UiTab },
    { url: "ui-pagination", component: UiPagination },
    { url: "ui-typography", component: UiTypography },
    { url: "ui-grid", component: UiGrid },

    /// Plugin
    { url: "uc-select2", component: Select2 },
    { url: "uc-noui-slider", component: MainNouiSlider },
    { url: "uc-sweetalert", component: MainSweetAlert },
    { url: "uc-toastr", component: Toastr },
    { url: "uc-lightgallery", component: Lightgallery },

    ///Redux
    { url: "todo", component: Todo },

    /// Widget
    { url: "widget-basic", component: Widget },

    /// Shop
    { url: "ecom-product-grid", component: ProductGrid },
    { url: "ecom-product-list", component: ProductList },
    { url: "ecom-product-detail", component: ProductDetail },
    { url: "ecom-product-order", component: ProductOrder },
    { url: "ecom-checkout", component: Checkout },
    { url: "ecom-invoice", component: Invoice },
    { url: "ecom-product-detail", component: ProductDetail },
    { url: "ecom-customers", component: Customers },

    /// Form
    { url: "form-element", component: Element },
    { url: "form-wizard", component: Wizard },
    { url: "form-editor-summernote", component: SummerNote },
    { url: "form-pickers", component: Pickers },
    { url: "form-validation-jquery", component: jQueryValidation },

    /// table
    { url: "table-filtering", component: FilteringTable },
    { url: "table-sorting", component: SortingTable },
    { url: "table-datatable-basic", component: DataTable },
    { url: "table-bootstrap-basic", component: BootstrapTable },

    /// pages
    { url: "page-register", component: Registration },
    { url: "page-lock-screen", component: LockScreen },
    { url: "page-login", component: Login },
    { url: "page-forgot-password", component: ForgotPassword },
    { url: "page-error-404", component: Error404 },

    { url: "WebCMS/by-interest", component: AttractionsByInterest },
    { url: "WebCMS/by-region", component: AttractionsByDestination },
    { url: "WebCMS/by-site", component: AttractionsBySite },

    { url: "WebCMS/main-pages", component: MainPages },

    { url: "WebCMS/plan-a-trip", component: Service, props: { type: "tour" } },
    { url: "WebCMS/events", component: Service, props: { type: "event" } },
    {
      url: "WebCMS/festivals",
      component: Service,
      props: { type: "festival" },
    },
    { url: "WebCMS/create-content", component: ContentPage },

    { url: "WebCMS/newsletter-subscribers", component: NewsletterSubscriber },

    { url: "users", component: User },
    ,
  ];
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  let pagePath = path.split("-").includes("page");
  return (
    <>
      <div
        id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${!pagePath ? "show" : "mh100vh"}  ${
          menuToggle ? "menu-toggle" : ""
        }`}
      >
        {!pagePath && <Nav />}

        <div
          className={`${!pagePath ? "content-body" : ""}`}
          style={{ minHeight: window.screen.height - 45, paddingRight: '0px' }}
        >
          <div className={`${!pagePath ? "container-fluid" : ""}`}>
            <Switch>
              {routes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`/${data.url}`}
                  // component={data.component}
                  render={(routeProps) =>
                    data.props ? (
                      <data.component {...routeProps} {...data.props} />
                    ) : (
                      <data.component {...routeProps} />
                    )
                  }
                />
              ))}
            </Switch>
          </div>
        </div>
        {!pagePath && <Footer />}
      </div>
      <ScrollToTop />
    </>
  );
};

export default Markup;
